"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var EnquiryFormTitle_1 = require("../enquiryFormTitle/EnquiryFormTitle");
var objectFieldTemplateStyles_1 = require("./objectFieldTemplateStyles");
exports.ObjectFieldTemplate = function (props) {
    var _a;
    var styles = objectFieldTemplateStyles_1.default();
    var properties = props.properties, $id = props.idSchema.$id, title = props.title;
    var isRoot = $id === 'root';
    return (<>
      {isRoot && <EnquiryFormTitle_1.default title={title}/>}
      <core_1.Grid container={true} direction={isRoot ? 'column' : 'row'}>
        {(_a = properties) === null || _a === void 0 ? void 0 : _a.map(function (field, index) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var fieldUiSchema = (_d = (_c = (_b = (_a = field) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.uiSchema) === null || _d === void 0 ? void 0 : _d['ui:options'];
        var width = typeof ((_e = fieldUiSchema) === null || _e === void 0 ? void 0 : _e.width) === 'string' ? parseInt((_f = fieldUiSchema) === null || _f === void 0 ? void 0 : _f.width, 10) : (_g = fieldUiSchema) === null || _g === void 0 ? void 0 : _g.width;
        var isHidden = !!((_h = fieldUiSchema) === null || _h === void 0 ? void 0 : _h.hide);
        // Rows with a single field have a single string as form data and not objects as rows with multiple fields.
        var hasSingleField = typeof ((_l = (_k = (_j = field) === null || _j === void 0 ? void 0 : _j.content) === null || _k === void 0 ? void 0 : _k.props) === null || _l === void 0 ? void 0 : _l.formData) === 'string';
        if (isHidden) {
            return null;
        }
        if (isRoot) {
            return (<core_1.Grid item={true} xs={12} key={index} className={hasSingleField ? styles.singleField : styles.root}>
                <core_1.Typography component={'span'} variant={'body2'}>
                  {field.content}
                </core_1.Typography>
              </core_1.Grid>);
        }
        return (<core_1.Grid item={true} key={index} xs={12} sm={width || (properties.length > 2 ? 4 : 6)} className={styles.child}>
              {field.content}
            </core_1.Grid>);
    })}
      </core_1.Grid>
    </>);
};
exports.default = exports.ObjectFieldTemplate;
